let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jDYGi")).then(() => parcelRequire('dIuHq'));